var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "multipleTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "header-cell-style": {
              backgroundColor: "#FDEFE7",
              color: "#000000",
            },
            "tree-props": { children: "children" },
            border: "",
            "default-expand-all": "",
            "row-key": "orderChildrenId",
          },
          on: {
            select: _vm.handleSelectionChange,
            "select-all": _vm.handleSelectionAllChange,
          },
        },
        [
          _c("el-table-column", {
            attrs: { align: "center", type: "selection", width: "55" },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "团号",
              prop: "planId",
              width: "80",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "子订单号",
              prop: "date",
              width: "230",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "tableLine1" }, [
                      _c("div", { staticClass: "btns1" }, [
                        _vm._v(_vm._s(scope.row.stateName)),
                      ]),
                      _c("p", { staticClass: "p1" }, [_vm._v("平台操作记录")]),
                    ]),
                    _c(
                      "p",
                      {
                        staticClass: "p2",
                        staticStyle: {
                          cursor: "pointer",
                          "text-decoration": "underline",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.openTheOrderDetailsPopUpBox(
                              scope.row.orderChildrenId
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(scope.row.orderChildrenId))]
                    ),
                    _c("p", { staticClass: "p3" }, [
                      _vm._v(
                        _vm._s(
                          scope.row.resourceName
                            ? scope.row.resourceName
                            : scope.row.resourceNameEn
                        )
                      ),
                    ]),
                    _c("p", { staticClass: "p4" }, [
                      scope.row.linkName
                        ? _c("span", [
                            _c("img", {
                              staticStyle: { width: "10px", height: "10px" },
                              attrs: { src: require("../assert/城市.png") },
                            }),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "margin-left": "2px",
                                  color: "#dd5827",
                                  "font-weight": "700",
                                },
                              },
                              [_vm._v(_vm._s(scope.row.linkName))]
                            ),
                          ])
                        : _vm._e(),
                      scope.row.mealTextMap && scope.row.state === 4
                        ? _c(
                            "span",
                            { staticStyle: { "margin-left": "3px" } },
                            [
                              _c("img", {
                                staticStyle: {
                                  position: "relative",
                                  top: "2px",
                                  width: "12px",
                                  height: "12px",
                                },
                                attrs: { src: require("../assert/餐饮.png") },
                              }),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "margin-left": "2px",
                                    color: "#dd5827",
                                    "font-weight": "700",
                                  },
                                },
                                [_vm._v(_vm._s(scope.row.mealTextMap.mealText))]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _c("p", { staticClass: "p5" }, [
                      _vm._v(_vm._s(scope.row.stockCompanyName)),
                    ]),
                    scope.row.createName
                      ? _c("p", { staticClass: "p2" }, [
                          _vm._v(_vm._s(scope.row.createName)),
                        ])
                      : _vm._e(),
                    scope.row.associatedListMap
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "center",
                            },
                          },
                          [
                            (scope.row.orderType === 1 ||
                              scope.row.orderType === 5) &&
                            scope.row.associatedListMap["ORDER_CONFIRMED"] &&
                            scope.row.associatedListMap["ORDER_CONFIRMED"]
                              .length > 0
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "p",
                                      { staticStyle: { color: "#000" } },
                                      [_vm._v("你选择的资源如下:")]
                                    ),
                                    _vm._l(
                                      _vm.duplicateRemoval(
                                        scope.row.associatedListMap[
                                          "ORDER_CONFIRMED"
                                        ],
                                        "resourceId"
                                      ),
                                      function (n, m) {
                                        return _c(
                                          "p",
                                          { key: m, staticClass: "p6" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                n.resourceName
                                                  ? n.resourceName
                                                  : n.resourceNameEn
                                              )
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _c(
                                  "div",
                                  _vm._l(
                                    Object.keys(scope.row.associatedListMap),
                                    function (n, m) {
                                      return _c("span", { key: m }, [
                                        _vm.btnMap[n]
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "btns2",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.similarProductsClick(
                                                      scope.row
                                                        .associatedListMap,
                                                      n,
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.btnMap[n]) + " "
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-arrow-right",
                                                  staticStyle: {
                                                    "font-weight": "bold",
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ])
                                    }
                                  ),
                                  0
                                ),
                          ]
                        )
                      : _vm._e(),
                    (scope.row.orderType === 5 || scope.row.orderType === 1) &&
                    (!scope.row.associatedListMap ||
                      !scope.row.associatedListMap["ORDER_CONFIRMED"] ||
                      !scope.row.associatedListMap["ORDER_CONFIRMED"].length)
                      ? _c(
                          "div",
                          { staticStyle: { "margin-bottom": "0.1rem" } },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectResources(scope.row)
                                  },
                                },
                              },
                              [_vm._v("选择资源")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    scope.row.listByStockListResults &&
                    scope.row.listByStockListResults.length > 0
                      ? _c(
                          "span",
                          {
                            staticClass: "btns2",
                            staticStyle: { display: "inline-block" },
                            on: {
                              click: function ($event) {
                                return _vm.handlerStockClick(
                                  scope.row.listByStockListResults,
                                  scope.row.orderChildrenId
                                )
                              },
                            },
                          },
                          [_vm._v(" 商品变更 点击查看 ")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "商品",
              prop: "name",
              width: "210",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _vm._l(
                    scope.row.orderListDetailResultList,
                    function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "tableLine2" },
                        [
                          _c("p", { staticClass: "p1" }, [
                            _c("span", { staticClass: "span1" }, [
                              _vm._v(
                                _vm._s(item.number) +
                                  " " +
                                  _vm._s(item.priceCompany)
                              ),
                            ]),
                            item.productName && item.productName !== "0"
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "span2",
                                    on: {
                                      click: function ($event) {
                                        return _vm.openOrderSnapshot(
                                          scope.row,
                                          item
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(item.productName))]
                                )
                              : _vm._e(),
                          ]),
                          _c("p", { staticClass: "p1" }, [
                            item.stockId != 0
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "span2",
                                    staticStyle: {
                                      "font-weight": "400",
                                      color: "#333333",
                                    },
                                  },
                                  [_vm._v(_vm._s(item.stockId) + " ")]
                                )
                              : _vm._e(),
                          ]),
                          _c(
                            "p",
                            {
                              staticClass: "p1",
                              staticStyle: { "margin-bottom": "0" },
                            },
                            [
                              _c("span", { staticClass: "span1" }, [
                                _vm._v(
                                  _vm._s(item.number) +
                                    " " +
                                    _vm._s(item.priceCompany)
                                ),
                              ]),
                              scope.row.state === 0
                                ? _c("span", { staticClass: "span4" }, [
                                    _vm._v(
                                      _vm._s(item.startTime) +
                                        "-" +
                                        _vm._s(_vm.addOneDay(item.endTime))
                                    ),
                                  ])
                                : item.startTime === item.endTime
                                ? _c("span", { staticClass: "span4" }, [
                                    _vm._v(_vm._s(item.startTime)),
                                  ])
                                : _c("span", { staticClass: "span4" }, [
                                    _vm._v(
                                      _vm._s(item.startTime) +
                                        "-" +
                                        _vm._s(item.endTime)
                                    ),
                                  ]),
                            ]
                          ),
                          _c("p", { staticClass: "p3" }),
                        ]
                      )
                    }
                  )
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "单元（元）*数量 *汇率 ",
              prop: "address",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _vm._l(
                    scope.row.orderListDetailResultList,
                    function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "tableLine3" },
                        [
                          _c("p", { staticClass: "p1" }, [
                            _vm._v(
                              _vm._s(item.currency) +
                                _vm._s(item.price) +
                                "/" +
                                _vm._s(item.priceCompany)
                            ),
                            item.useTime ? _c("span", [_vm._v("/")]) : _vm._e(),
                            _vm._v(" " + _vm._s(item.useTime)),
                          ]),
                          _c("p", { staticClass: "p2" }, [
                            _vm._v(
                              _vm._s(item.number + item.priceCompany) +
                                " " +
                                _vm._s(
                                  _vm.days(
                                    item.startTime,
                                    item.endTime,
                                    scope.row.state
                                  ) + 1
                                ) +
                                _vm._s(item.useTime ? item.useTime : "天")
                            ),
                          ]),
                          item.rate != 1
                            ? _c("p", { staticClass: "p3" }, [
                                _c(
                                  "span",
                                  { staticStyle: { color: "#5F6266" } },
                                  [_vm._v(" 汇率：" + _vm._s(item.rate) + " ")]
                                ),
                              ])
                            : _vm._e(),
                          item.cancelNumber > 0
                            ? _c("p", { staticClass: "lp4" }, [
                                _vm._v(
                                  "已取消的数量：" + _vm._s(item.cancelNumber)
                                ),
                              ])
                            : _vm._e(),
                        ]
                      )
                    }
                  )
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "商品总价（元）",
              prop: "name",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "tableLine4" }, [
                      _c(
                        "p",
                        {
                          staticClass: "p1",
                          staticStyle: { "margin-bottom": "0" },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.totalPrice(
                                scope.row.orderListDetailResultList
                              )
                            ) + "￥"
                          ),
                        ]
                      ),
                      _vm.dataType == 1
                        ? _c("p", [
                            _vm._v("利润："),
                            _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.profitPrice(scope.row.tbudgetDetails)
                                ) + "¥"
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "min-width": _vm.operationWidth,
              fixed: "right",
              label: "订单状态及操作",
              prop: "address",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.truncationResult && _vm.isOperation
                      ? _c(
                          "div",
                          {
                            staticClass: "tableLine4",
                            staticStyle: {
                              width: "100%",
                              display: "flex",
                              "align-items": "center",
                              "padding-left": "0.5rem",
                            },
                          },
                          [
                            _c("bookState", {
                              attrs: {
                                allDatas: scope.row,
                                dataType: _vm.dataType,
                                datas: scope.row.truncationResult,
                                orderChildrenId: scope.row.orderChildrenId,
                                orderMainId: scope.row.orderMainId,
                                totalPrice: _vm.totalPrice(
                                  scope.row.orderListDetailResultList
                                ),
                              },
                              on: {
                                handlerSeeConfirm: _vm.handlerSeeConfirm,
                                openPay: _vm.openPay,
                                updateList: _vm.updateList,
                              },
                            }),
                            scope.row.approvalProcessMapResult
                              ? _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "0.2rem" },
                                    attrs: { size: "mini", type: "success" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.approvalDetails(
                                          scope.row.orderMainId
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("审批详情 ")]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "btns3",
                                attrs: { size: "mini", type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.confirmOrderPlacement(scope.row)
                                  },
                                },
                              },
                              [_vm._v("确认下单 ")]
                            ),
                          ],
                          1
                        ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("closeBookPopup", { ref: "closeBookPopup" }),
      _vm.isOperation
        ? _c("similarProductsPopup", { ref: "similarProductsPopup" })
        : _vm._e(),
      _c("resourceSelection", {
        ref: "resourceSelection",
        on: { updateList: _vm.updateList },
      }),
      _c("createAVehicleOrder", {
        ref: "createAVehicleOrder",
        attrs: { detection: "" },
      }),
      _c("orderPageSnapshot", { ref: "orderPageSnapshot" }),
      _c("resourceSelectionNew", {
        ref: "resourceSelectionNew",
        on: { updateList: _vm.updateList },
      }),
      _c(
        "el-drawer",
        {
          attrs: {
            data: _vm.tableData,
            visible: _vm.drawer,
            "append-to-body": "",
            direction: "rtl",
            title: "审批详情",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { padding: "0.1rem" } },
            _vm._l(_vm.approvalData, function (items, indexs) {
              return _c(
                "div",
                {
                  key: indexs,
                  staticStyle: {
                    padding: "0.2rem",
                    "margin-bottom": "0.3rem",
                    position: "relative",
                    "box-shadow": "rgba(149, 157, 165, 0.2) 0px 8px 24px",
                  },
                },
                [
                  items.applyFlag != 1
                    ? _c(
                        "el-button",
                        {
                          staticStyle: {
                            position: "absolute",
                            right: "0.2rem",
                            top: "0.2rem",
                          },
                          attrs: {
                            loading: _vm.isLoading,
                            size: "small",
                            type: "primary",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.auditing(items)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              items.applyFlag == 0 ? "催审" : "重新发起审核"
                            ) + " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c("div", { staticStyle: { "margin-bottom": "0.2rem" } }, [
                    _c(
                      "p",
                      {
                        staticStyle: {
                          "font-weight": "bold",
                          "font-size": "0.18rem",
                          "margin-bottom": "0.05rem",
                        },
                      },
                      [
                        _vm._v("发起人："),
                        _c("span", [_vm._v(_vm._s(items.createName))]),
                      ]
                    ),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          "font-weight": "bold",
                          "font-size": "0.18rem",
                          "margin-bottom": "0.05rem",
                        },
                      },
                      [
                        _vm._v("发起审核时间："),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("dateFormatHms")(items.createTime))
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          "font-weight": "bold",
                          "font-size": "0.18rem",
                          "margin-bottom": "0.05rem",
                        },
                      },
                      [
                        _vm._v("发起人公司："),
                        _c("span", [_vm._v(_vm._s(items.createCompanyName))]),
                      ]
                    ),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          "font-weight": "bold",
                          "font-size": "0.18rem",
                          "margin-bottom": "0.05rem",
                        },
                      },
                      [
                        _vm._v("审核状态： "),
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                items.applyFlag == 1
                                  ? "success"
                                  : items.applyFlag == 2
                                  ? "error"
                                  : "info",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.approvalMap[items.applyFlag]) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._l(
                    items.stepApprovalProcessResults,
                    function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticStyle: { display: "flex" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                "flex-direction": "column",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  class: {
                                    active: item.statusText === "审批通过",
                                  },
                                  staticStyle: {
                                    height: "0.35rem",
                                    width: "0.35rem",
                                    display: "flex",
                                    border: "2px solid #C1C4CB",
                                    "border-radius": "50%",
                                    "justify-content": "center",
                                    "font-size": "0.22rem",
                                    "font-weight": "bold",
                                    color: "#C1C4CB",
                                  },
                                },
                                [_vm._v(" " + _vm._s(item.step) + " ")]
                              ),
                              index !==
                              items.stepApprovalProcessResults.length - 1
                                ? _c("div", {
                                    staticStyle: {
                                      "min-height": "0.7rem",
                                      width: "1px",
                                      "border-right": "2px solid #C1C4CB",
                                      flex: "1",
                                    },
                                  })
                                : _vm._e(),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-left": "0.2rem",
                                "font-size": "0.18rem",
                                "margin-top": "0.05rem",
                              },
                            },
                            [
                              _c(
                                "p",
                                { staticStyle: { "margin-bottom": "0.1rem" } },
                                [
                                  _vm._v(
                                    "审核人名称：" +
                                      _vm._s(
                                        item.applyName
                                          ? item.applyName
                                          : item.approvalProcessResultList
                                              .map((n) => n.applyName)
                                              .join("、")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "el-tag",
                                {
                                  staticStyle: { "margin-bottom": "0.1rem" },
                                  attrs: {
                                    type:
                                      item.statusText === "审批通过"
                                        ? "success"
                                        : item.statusText === "审批驳回"
                                        ? "error"
                                        : "info",
                                  },
                                },
                                [_vm._v(" " + _vm._s(item.statusText) + " ")]
                              ),
                              item.returnMsg && item.returnMsg.length > 0
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "font-size": "0.16rem",
                                        color: "#5F6266",
                                      },
                                    },
                                    [
                                      _c("p", [_vm._v("驳回理由:")]),
                                      _c(
                                        "div",
                                        _vm._l(
                                          item.returnMsg,
                                          function (remark, m) {
                                            return _c("p", { key: m }, [
                                              _vm._v(" " + _vm._s(remark)),
                                            ])
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              item.applyName && item.applyTime
                                ? _c("div", [
                                    _c(
                                      "p",
                                      {
                                        staticStyle: { "font-size": "0.13rem" },
                                      },
                                      [
                                        _vm._v(
                                          "审核执行人：" +
                                            _vm._s(item.applyName)
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "p",
                                      {
                                        staticStyle: { "font-size": "0.13rem" },
                                      },
                                      [
                                        _vm._v(
                                          "审核时间：" + _vm._s(item.applyTime)
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      )
                    }
                  ),
                ],
                2
              )
            }),
            0
          ),
        ]
      ),
      _c("orderDetailsPopUpBox", { ref: "orderDetailsPopUpBox" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }